<template>
  <MarketItemWrapper
    :index="index"
    :name="name"
    :checked="checked"
    :disabled="disabled"
    :image="image"
    :soldOut="soldOut"
    :isPurchasable="isPurchasable"
    :isUnpurchasable="isUnpurchasable"
    :notFirstPurchase="notFirstPurchase"
    :notFirstPurchaseGuest="notFirstPurchaseGuest"
    :firstPurchaseOnlyProduct="firstPurchaseOnlyProduct"
    :stockCount="stockCount"
    :retailPrice="retailPrice"
    :salePrice="salePrice"
    :quantity="quantity"
    :minCount="minCount"
    :maxCount="maxCount"
    :onChecked="onChecked"
    :onDelete="onDelete"
    :onMoveDetail="onMoveDetail"
    :returnOrExchange="returnOrExchange"
  >
    <VCheckBox
      v-if="!isUnpurchasable"
      slot="title"
      class="product-name"
      :name="`${name}-${index}`"
      :checked="checked"
      :onChecked="onChecked"
      :disabled="locked"
    >
      <VSpan :size="18" :color="TextColor.darkGray" :text="name" />
    </VCheckBox>
    <VBlock v-else slot="title" class="product-name-block">
      <VSpan class="product-name" :text="name" :size="18" :color="TextColor.inactive" />
    </VBlock>

    <slot></slot>
  </MarketItemWrapper>
</template>

<script>
import VBlock from '@/presentationals/v2/components/layouts/molecules/VBlock'
import VCheckBox from '@/presentationals/v2/components/layouts/atoms/VCheckBox'
import VSpan, { TextColor } from '@/presentationals/v2/components/layouts/atoms/VSpan'

import MarketItemWrapper from '../MarketItemWrapper'

export default {
  name: 'MarketItem',
  props: {
    index: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    checked: {
      type: Boolean,
      required: true
    },
    locked: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    soldOut: {
      type: Boolean,
      required: true
    },
    isPurchasable: {
      type: Boolean,
      required: true
    },
    isUnpurchasable: {
      type: Boolean,
      required: true
    },
    firstPurchaseOnlyProduct: {
      type: Boolean,
      required: true
    },
    notFirstPurchase: {
      type: Boolean,
      required: true
    },
    notFirstPurchaseGuest: {
      type: Boolean,
      required: true
    },
    stockCount: {
      type: Number,
      required: true
    },
    salePrice: {
      type: Number,
      required: true
    },
    retailPrice: {
      type: Number,
      required: true
    },
    quantity: {
      type: Number,
      required: true
    },
    minCount: {
      type: Number,
      required: true
    },
    maxCount: {
      type: Number,
      required: true
    },
    returnOrExchange: {
      type: Boolean,
      required: true
    },
    onChecked: {
      type: Function,
      required: true
    },
    onDelete: {
      type: Function,
      required: true
    },
    onMoveDetail: {
      type: Function,
      required: true
    }
  },
  components: {
    VCheckBox,
    VSpan,
    VBlock,

    MarketItemWrapper
  },
  data() {
    return {
      TextColor
    }
  },
  extends: [MarketItemWrapper]
}
</script>

<style lang="scss" scoped>
.product-name {
  width: 100%;
  line-height: 28px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-name-block {
  width: calc(100% - 50px);

  .product-name {
    width: 100%;
    line-height: 28px;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>